// src/Form.tsx
import React, {  } from 'react';
import { SummaryRow } from './SummaryRow';
import { getResourceString } from './../../../kentico/resource-strings';

export const FormSummary = ({formSummaryData, formData, formFields, navigateToStep }) => {
  return (
    <div className="form-summary">
      {formSummaryData.sections.filter((section) => section.visible === undefined || section.visible).map((section, sectionIndex) => (
        <div className={`summary-group ${section.className}`} key={sectionIndex}>
          {/* Section header div with dynamic class */}
          <div className={`summary-group__header ${section.headerClass}`}>
            <h5>{section.title}</h5>
            {section.navigateToStep !== undefined && (
              <a
                className="summary-group__select-step"
                onClick={() => navigateToStep(section.navigateToStep)}
              >
                {getResourceString("Form.Summary.Modify")}
              </a>
            )}
          </div>

          {/* Section content div with dynamic class */}
          <div className={`summary-group__content ${section.contentClass}`}>
            {section.rows.map((row, rowIndex) => {
              if (row.visible === false || (row.visible && !row.visible)) {
                return null;
              }

              return (
                <SummaryRow
                  key={rowIndex}
                  fieldName={row.fieldName}
                  formData={formData}
                  formFields={formFields}
                  dataOverride={row.dataOverride}
                  labelOverride={row.labelOverride}
                  className={row.className} // Apply row-level class here
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};